import { SsoSettingsRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/security/sso')({
  component: SsoSettingsRoute,
});
